import React from 'react'
import { useCallback, useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  BulkActionsProps,
  BulkActionAddNoteButton,
  useBulkActionContext,
  BulkAddNotesModel,
} from '@user/components/xGrid'
import { useAppSelector } from '@user/store/hooks'

import {
  selectAllOpportunities,
  selectOpportunityById,
} from '@user/store/opportunity'
import { NotesDrawer, useNotesDrawer } from '../../OpportunityCard/NotesDrawer'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = BulkActionsProps & { hasPermission: boolean }

export default function OpportunityBulkAddNote(props: Props) {
  const { hasPermission, selectedRows } = props

  const [showBulkAddModel, setShowBulkAddModel] = useState(false)
  const { dispatch } = useBulkActionContext()
  const allOpportunities = useSelector(selectAllOpportunities)

  const notesState = useNotesDrawer({
    canUpdate: hasPermission,
    detailPage: true,
  })

  const isMultipleSelected = selectedRows.size > 1 ? true : false

  useEffect(() => {
    if (!isMultipleSelected) {
      dispatch({ type: 'setActive' })
    }
    if (isMultipleSelected && !showBulkAddModel) {
      dispatch({ type: 'setActive' })
    }
  }, [dispatch, showBulkAddModel, isMultipleSelected])

  const ids = useMemo(
    () => [...selectedRows.keys()].map((k) => Number(k)),
    [selectedRows],
  )

  const entityId = ids[0]
  const opportunity = useAppSelector((state) =>
    selectOpportunityById(state, entityId),
  )
  const opportunities = allOpportunities?.filter((row) =>
    ids?.includes(row?.id),
  )

  const onButtonClick = useCallback(() => {
    if (isMultipleSelected) {
      setShowBulkAddModel(true)
    }
    if (!isMultipleSelected) {
      notesState.showViewNoteModal()
    }
  }, [notesState, isMultipleSelected, setShowBulkAddModel])

  return (
    <>
      <BulkActionAddNoteButton
        hasPermission={hasPermission}
        onButtonClick={onButtonClick}
        recordCount={selectedRows.size}
      />
      {!isMultipleSelected && opportunity && (
        <NotesDrawer {...notesState} opportunity={opportunity} />
      )}
      {isMultipleSelected && (
        <BulkAddNotesModel
          open={showBulkAddModel}
          onClose={() => setShowBulkAddModel(false)}
          entityType={ENTITY_TYPES.Opportunity}
          data={opportunities}
        />
      )}
    </>
  )
}
